import Land from './Land/Land.js'
import Tree from './Tree/Tree.js'
import BasicLights from './Lights.js'
import Launcher from './Launcher/Launcher.js'
import { Group, SphereGeometry, Mesh, Vector3, MeshBasicMaterial } from 'three'
export default class SeedScene extends Group {
  constructor () {
    super()
    this.launchers = []
    const land = new Land()
    const lights = new BasicLights()
    const tree = new Tree()
    const launcher = new Launcher()
    this.launchers.push(launcher)
    this.add(land, lights, tree, launcher)

    // var fw = new FireworkShaderMaterial()
    // var material = fw.getMaterial()
    this.wsPoint = new Vector3(0, 10, 0)
    let geometry = new SphereGeometry(1, 32, 32)
    let testObj = new Mesh(geometry, new MeshBasicMaterial({ color: 0x0000ff }))
    testObj.position.copy(this.wsPoint)
    // this.add(testObj)
  //   for(let i = 0; i < 5; i++)
  //   {
  //     let geometry = new SphereGeometry( i*2+0.5, 32, 32 )
  //     let testObj = new Mesh( geometry, material )
  //     testObj.position.set(10+-10*i,i*5,0)
  //     this.add(testObj)
  // }
  }

  getDebug (debugPanel) {
    debugPanel['Pw'] = this.wsPoint.toArray()
  }
  getFireworkPoints () {
    var points = []
    // points.push({
    //   position: new Vector3(0.5,0.5,0),
    //   color: 0x0000FF,
    //   intensity: 0.0001
    // }
    // )
    this.launchers[0].traverseVisible((o) => {
      if ('getFireworkData' in o) {
        let data = o.getFireworkData()
        if (data != null) { points.push(data) }
      }
    }
    )
    return points
  }
  addFirework (firework) {
    this.launchers[0].launch(firework)
  }
  addFireworkSpread () {
    this.launchers[0].launchSpread()
  }
  update (timeStamp) {
    // this.rotation.y = timeStamp / 10000;
    for (var launcher of this.launchers) {
      launcher.update(timeStamp)
    }
  }
  updateCameraTarget () {
    return this.fireworks[0].lookAtPosition()
  }
}
